import { useTranslation } from "react-i18next";

const MapSection = () => {
  const { i18n } = useTranslation();
  const isEs = i18n.language === "es";

  return (
    <section className="pt-10 pb-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 items-center">

          {/* Left: Info */}
          <div className="lg:w-2/5 w-full">
            <span className="inline-block text-brand-green font-body text-sm font-semibold tracking-widest uppercase mb-3">
              {isEs ? "Nuestra Ubicación" : "Our Location"}
            </span>
            <h2 className="font-heading font-black text-brand-dark text-3xl md:text-4xl mb-4">
              {isEs ? "Sirviendo a " : "Proudly Serving "}
              <span className="text-brand-green">
                {isEs ? "Royal Palm Beach & Alrededores" : "Royal Palm Beach & Surrounding Areas"}
              </span>
            </h2>
            <p className="font-body text-gray-500 text-base mb-8 leading-relaxed">
              {isEs
                ? "Estamos ubicados en Royal Palm Beach, FL y atendemos a toda el área de Palm Beach County. ¡Contáctanos hoy para una cotización gratis!"
                : "Based in Royal Palm Beach, FL, we serve all of Palm Beach County. Contact us today for a free quote!"}
            </p>

            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-green/10 text-brand-green flex-shrink-0">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <div>
                  <p className="font-heading font-semibold text-brand-dark text-sm">
                    {isEs ? "Dirección" : "Address"}
                  </p>
                  <p className="font-body text-gray-500 text-sm">10639 Misty Ln, Royal Palm Beach, FL 33411</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-green/10 text-brand-green flex-shrink-0">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <div>
                  <p className="font-heading font-semibold text-brand-dark text-sm">
                    {isEs ? "Teléfono" : "Phone"}
                  </p>
                  <a href="tel:+15612626118" className="font-body text-gray-500 text-sm hover:text-brand-green transition-colors cursor-pointer">
                    (561) 262-6118
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-green/10 text-brand-green flex-shrink-0">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <p className="font-heading font-semibold text-brand-dark text-sm">
                    {isEs ? "Horario" : "Hours"}
                  </p>
                  <p className="font-body text-gray-500 text-sm">
                    {isEs ? "Lun – Sáb: 8:00 AM – 4:00 PM" : "Mon – Sat: 8:00 AM – 4:00 PM"}
                  </p>
                </div>
              </div>
            </div>

            <a
              href="https://wa.me/15612626118"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-8 bg-brand-green hover:bg-brand-green-dark text-white px-7 py-3.5 rounded-full font-heading font-semibold text-sm transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              {isEs ? "Solicitar Cotización Gratis" : "Request a Free Quote"}
            </a>
          </div>

          {/* Right: Map */}
          <div className="lg:w-3/5 w-full rounded-2xl overflow-hidden" style={{ height: "450px" }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3564.6433440494666!2d-80.21460642477173!3d26.691886876779407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d92f1fb7365f2d%3A0x12c37bf3f18362b2!2s10639%20Misty%20Ln%2C%20Royal%20Palm%20Beach%2C%20FL%2033411%2C%20USA!5e0!3m2!1sen!2sco!4v1775489619297!5m2!1sen!2sco"
              width="100%"
              height="100%"
              style={{ border: 0, display: "block" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Adry & Mich Location"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default MapSection;
